
import React from 'react';
import { MoreHorizontal, Play, Share2, Download, BarChart2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger 
} from '@/components/ui/dropdown-menu';
import { Link } from 'react-router-dom';

interface ReleaseCardMenuProps {
  id: string;
  onPlay: () => void;
  onShare: () => void;
}

const ReleaseCardMenu: React.FC<ReleaseCardMenuProps> = ({
  id,
  onPlay,
  onShare
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="rounded-full h-8 w-8">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="glass-panel w-48" align="end">
        <DropdownMenuLabel>Options</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onPlay}>
          <Play className="mr-2 h-4 w-4" />
          <span>Play Release</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onShare}>
          <Share2 className="mr-2 h-4 w-4" />
          <span>Share</span>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Download className="mr-2 h-4 w-4" />
          <span>Download</span>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to={`/releases/${id}`}>
            <BarChart2 className="mr-2 h-4 w-4" />
            <span>View Analytics</span>
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ReleaseCardMenu;
